import React from "react";
import { Chevron } from "../../assets/svgs/icons";
import ListDropdown from "./Dropdown";

export type { default as ListDropdownProps } from "./Dropdown";

export interface ListProps {
  icon?: React.ReactNode;
  label: string;
  type?: "link" | "action";
  style?: "horizontal" | "vertical";
  onClick?: () => void;
}

const List: React.FC<ListProps> = ({
  icon,
  label,
  type = "link",
  style = "horizontal",
  onClick,
}) => {
  // Horizontal layout
  if (style === "horizontal") {
    return (
      <div
        className={
          "box-border flex items-center min-h-[48px] pl-4 gap-2 cursor-pointer transition " +
          "hover:bg-[#f7f7f7] rounded-[20px]"
        }
        style={{ position: "relative" }}
        data-name={`type=${type}, style=horizontal`}
        onClick={onClick}
      >
        {icon && (
          <span className="shrink-0 w-5 h-5 flex items-center justify-center">
            {icon}
          </span>
        )}
        <span
          className={
            type === "action"
              ? "flex-1 font-medium text-[#666666] text-[14px] tracking-[-0.28px] leading-5"
              : "flex-1 font-medium text-[#212121] text-[14px] tracking-[-0.28px] leading-5"
          }
        >
          {label}
        </span>
        {type === "link" && (
          <span className="shrink-0 w-12 h-12 flex items-center justify-center absolute right-0 top-1/2 -translate-y-1/2">
            <Chevron width={24} height={24} />
          </span>
        )}
      </div>
    );
  }
  // Vertical layout
  if (style === "vertical") {
    return (
      <div
        className="box-border flex flex-col gap-3 items-center justify-center p-4 w-[84px] cursor-pointer transition hover:bg-[#f7f7f7] rounded-[8px]"
        data-name={`type=${type}, style=vertical`}
        onClick={onClick}
      >
        {icon && (
          <span className="shrink-0 w-5 h-5 flex items-center justify-center">
            {icon}
          </span>
        )}
        <span className="font-medium text-[#212121] text-[14px] tracking-[-0.28px] leading-5 whitespace-nowrap">
          {label}
        </span>
      </div>
    );
  }
  // fallback
  return null;
};

const ListWithComponents = Object.assign(List, {
  Dropdown: ListDropdown,
});

export default ListWithComponents;

// 개별 import 지원
export { ListDropdown };
